import { Fragment } from "react";
import VaporHeaderBar from "@vapor/react-custom/VaporHeaderBar";
import IconButton from "@vapor/react-material/IconButton";
import Drawer from "@vapor/react-material/Drawer";
import Box from "@vapor/react-material/Box";
import Tooltip from "@vapor/react-material/Tooltip";
import ExtendedTabs from "@vapor/react-extended/ExtendedTabs";
import ExtendedTab from "@vapor/react-extended/ExtendedTab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import {
	Print as PrintIcon,
	Search as SearchIcon,
	Close as CloseIcon,
	AttachFile as AttachFileIcon,
	Sos as SosIcon,
	ErrorOutlineOutlined as ErrorIcon,
} from "@mui/icons-material";
import { BancaDatiTab } from "./BancaDatiTab";
import { AllegatiTab } from "./AllegatiTab";
import { NewAllegatiTab } from "./NewAllegatiTab";
import { DocumentiTab } from "./DocumentiTab";
import { SosTab } from "./SosTab";

export const FascicoloDrawer = ({
	tenantId,
	// Drawer
	openDrawer,
	drawerTabValue,
	drawerHeaderTitle,
	drawerHeaderDesc,
	handleDrawer,
	handleDrawerTabChange,
	openDrawerAction,
	// Common
	backDropInternalOpen,
	selectedTab,
	userPermissions,
	userPermissionsSOS,
	utentiList,
	selFascicolo,
	hasUnavailableAllegati,
	tenantTypeId,
	// BancaDati
	bancaDatiTabValue,
	bancaDatiResult,
	currentAnagrafica,
	hasBancaDatiAbb,
	bancaDatiAbbCredits,
	bancaDatiAbbProductsList,
	bancaDatiAbbProductBought,
	currentAnagraficheList,
	anagraficheBancaDatiList,
	handleChangeBancaDatiTab,
	handleCheckBancaDatiClick,
	handleDetailBancaDatiClick,
	handleBancaDatiBuyProduct,
	// Allegati
	allBrowserFiles,
	currentAllegati,
	handleEuroConfClick,
	handleRefreshAllegati,
	handleUploadFile,
	handleDownloadAllegatoClick,
	handleDeleteAllegatoClick,
	// Documenti
	printList,
	selectedPrint,
	filteredUtentiList,
	selectedUsers,
	printDate,
	printCessato,
	printCessPrest,
	prestazioniList,
	rischiList,
	selectedRischiToPrint,
	filteredSOSList,
	selectedSOSToPrint,
	selectedProfToPrint,
	indAnomaliaList,
	selectedIndAnomaliaToPrint,
	handlePrintChange,
	handleUserChange,
	handlePrintDate,
	handlePrintCessato,
	handlePrestToPrintClick,
	handleLegalForReport,
	handleRischiToPrintClick,
	handleSOSToPrintClick,
	handlePrintChangeDate,
	handlePrintClick,
	handleIndAnomaliaToPrintClick,
	// SOS
	currentSOS,
	sosAllegati,
	currentSOSList,
	pendingSosFiles,
	handleChangeDateSOS,
	handleChangeSOS,
	handleChangeDateRicUifSOS,
	handleCancelSOS,
	handleBtnAddSOSClick,
	handleDeleteSOSClick,
	handleSelectedSOSClick,
}) => {
	const drawerWidth = /*tenantId === 'b26529b5-6e97-469a-b53e-fc029c0666a4' &&*/ drawerTabValue === "allegati" ? "95%" : "45%";
	const tabsRight = openDrawer ? drawerWidth : "0";

	return (
		<Box sx={{ display: "flex", position: "fixed"}}>
			<Fragment key="right">
				<ExtendedTabs
					orientation="vertical"
					value={drawerTabValue}
					sx={{
						position: "fixed",
						right: tabsRight,
						top: "45%",
						zIndex : 1299
					}}
				>
					<ExtendedTab
						value="bancaDati"
						onClick={() => openDrawerAction("bancaDati")}
						icon={
							<Tooltip title="Banca dati" placement="left">
								<SearchIcon />
							</Tooltip>
						}
						disabled={selectedTab !== "tabAnagrafica"}
					/>
					<ExtendedTab
						value="allegati"
						onClick={() => openDrawerAction("allegati")}
						icon={
							<Tooltip title="Allegati" placement="left">
								{hasUnavailableAllegati ? (
									<ErrorIcon
										sx={{
											color: "#ff0000 !important",
											fill: "#ff0000 !important",
											"& path": {
												fill: "#ff0000 !important",
											},
										}}
										htmlColor="red"
									/>
								) : (
									<AttachFileIcon />
								)}
							</Tooltip>
						}
					/>
					<ExtendedTab
						value="documenti"
						onClick={() => openDrawerAction("documenti")}
						icon={
							<Tooltip title="Stampa" placement="left">
								<PrintIcon />
							</Tooltip>
						}
					/>
					{userPermissionsSOS.canRead ? (
						<ExtendedTab
							value="sos"
							onClick={() => openDrawerAction("sos")}
							icon={
								<Tooltip title="SOS" placement="left">
									<SosIcon />
								</Tooltip>
							}
						/>
					) : null}
				</ExtendedTabs>
			</Fragment>
			<Drawer
				anchor="right"
				open={openDrawer}
				onClose={handleDrawer}
				hideBackdrop
				width= {drawerWidth}
				sx={{ zIndex: 1300 }}
			>
				<TabContext value={drawerTabValue}>
					<ExtendedTabs
						value={drawerTabValue}
						onChange={handleDrawerTabChange}
						orientation="vertical"
						sx={{
							background: "white",
							position: "fixed",
							right: tabsRight,
							top: "45%",
						}}
					>
						<ExtendedTab
							value="bancaDati"
							icon={
								<Tooltip title="Banca dati" placement="left">
									<SearchIcon />
								</Tooltip>
							}
							iconPosition="start"
							disabled={selectedTab !== "tabAnagrafica"}
						/>
						<ExtendedTab
							value="allegati"
							icon={
								<Tooltip title={`Allegati ${selFascicolo?.name || ""}`} placement="left">
									<AttachFileIcon />
								</Tooltip>
							}
							iconPosition="start"
						/>
						<ExtendedTab
							value="documenti"
							icon={
								<Tooltip title="Stampa" placement="left">
									<PrintIcon />
								</Tooltip>
							}
							iconPosition="start"
						/>
						{userPermissionsSOS.canRead ? (
							<ExtendedTab
								value="sos"
								icon={
									<Tooltip title="SOS" placement="left">
										<SosIcon />
									</Tooltip>
								}
								iconPosition="start"
							/>
						) : null}
					</ExtendedTabs>
					<VaporHeaderBar
						divider
						title={drawerHeaderTitle}
						description={drawerHeaderDesc}
						rightItems={[
							<IconButton onClick={handleDrawer} color="primary">
								<CloseIcon />
							</IconButton>,
						]}
					/>
					<TabPanel value="bancaDati">
						<BancaDatiTab
							backDropInternalOpen={backDropInternalOpen}
							bancaDatiTabValue={bancaDatiTabValue}
							bancaDatiResult={bancaDatiResult}
							currentAnagrafica={currentAnagrafica}
							hasBancaDatiAbb={hasBancaDatiAbb}
							bancaDatiAbbCredits={bancaDatiAbbCredits}
							bancaDatiAbbProductsList={bancaDatiAbbProductsList}
							bancaDatiAbbProductBought={bancaDatiAbbProductBought}
							currentAnagraficheList={currentAnagraficheList}
							anagraficheBancaDatiList={anagraficheBancaDatiList}
							handleChangeBancaDatiTab={handleChangeBancaDatiTab}
							handleCheckBancaDatiClick={handleCheckBancaDatiClick}
							handleDetailBancaDatiClick={handleDetailBancaDatiClick}
							handleBancaDatiBuyProduct={handleBancaDatiBuyProduct}
						/>
					</TabPanel>
					<TabPanel value="allegati">
						{/* {tenantId !== 'b26529b5-6e97-469a-b53e-fc029c0666a4' ? (
							<AllegatiTab
								backDropInternalOpen={backDropInternalOpen}
								userPermissions={userPermissions}
								allBrowserFiles={allBrowserFiles}
								currentAllegati={currentAllegati}
								handleEuroConfClick={handleEuroConfClick}
								handleUploadFile={handleUploadFile}
								handleDownloadAllegatoClick={handleDownloadAllegatoClick}
								handleDeleteAllegatoClick={handleDeleteAllegatoClick}/>
							) : */}
							<NewAllegatiTab
								userPermissions={userPermissions}
								allBrowserFiles={allBrowserFiles}
								currentAllegati={currentAllegati}
								handleUploadFile={handleUploadFile}
								handleDownloadAllegatoClick={handleDownloadAllegatoClick}
								handleDeleteAllegatoClick={handleDeleteAllegatoClick}
								handleEuroConfClick={handleEuroConfClick}
								handleRefreshAllegati={handleRefreshAllegati}
							/>
						{/* } */}
					</TabPanel>
					<TabPanel value="documenti">
						<DocumentiTab
							backDropInternalOpen={backDropInternalOpen}
							printList={printList}
							selectedPrint={selectedPrint}
							filteredUtentiList={filteredUtentiList}
							selectedUsers={selectedUsers}
							printDate={printDate}
							printCessato={printCessato}
							printCessPrest={printCessPrest}
							prestazioniList={prestazioniList}
							utentiList={utentiList}
							rischiList={rischiList}
							selectedRischiToPrint={selectedRischiToPrint}
							filteredSOSList={filteredSOSList}
							selectedSOSToPrint={selectedSOSToPrint}
							selectedProfToPrint={selectedProfToPrint}
							indAnomaliaList={indAnomaliaList}
							selectedIndAnomaliaToPrint={selectedIndAnomaliaToPrint}
							selFascicolo={selFascicolo}
							tenantTypeId={tenantTypeId}
							handlePrintChange={handlePrintChange}
							handleUserChange={handleUserChange}
							handlePrintDate={handlePrintDate}
							handlePrintCessato={handlePrintCessato}
							handlePrestToPrintClick={handlePrestToPrintClick}
							handleLegalForReport={handleLegalForReport}
							handleRischiToPrintClick={handleRischiToPrintClick}
							handleSOSToPrintClick={handleSOSToPrintClick}
							handlePrintChangeDate={handlePrintChangeDate}
							handlePrintClick={handlePrintClick}
							handleIndAnomaliaToPrintClick={handleIndAnomaliaToPrintClick}
						/>
					</TabPanel>
					{userPermissionsSOS.canRead ? (
						<TabPanel value="sos">
							<SosTab
								backDropInternalOpen={backDropInternalOpen}
								currentSOS={currentSOS}
								sosAllegati={sosAllegati}
								currentSOSList={currentSOSList}
								pendingSosFiles={pendingSosFiles}
								utentiList={utentiList}
								userPermissions={userPermissions}
								userPermissionsSOS={userPermissionsSOS}
								allBrowserFiles={allBrowserFiles}
								handleChangeDateSOS={handleChangeDateSOS}
								handleChangeSOS={handleChangeSOS}
								handleChangeDateRicUifSOS={handleChangeDateRicUifSOS}
								handleCancelSOS={handleCancelSOS}
								handleBtnAddSOSClick={handleBtnAddSOSClick}
								handleDeleteSOSClick={handleDeleteSOSClick}
								handleSelectedSOSClick={handleSelectedSOSClick}
								handleUploadFile={handleUploadFile}
								handleDownloadAllegatoClick={handleDownloadAllegatoClick}
								handleDeleteAllegatoClick={handleDeleteAllegatoClick}
							/>
						</TabPanel>
					) : null}
				</TabContext>
			</Drawer>
		</Box>
	);
};
